import { useEffect, useRef, useState } from 'react';
import { useExchangeRate } from './use-exchange-rate';

export type Trend = 'up' | 'down' | 'stable';

interface ExchangeRateTrend {
  rate: number | null;
  trend: Trend;
  flashing: boolean;
}

/**
 * Wraps useExchangeRate with trend detection (up/down/stable)
 * and a brief flash flag on rate changes.
 */
export function useExchangeRateTrend(): ExchangeRateTrend {
  const { data } = useExchangeRate();
  const prevRate = useRef<number>();
  const [flashing, setFlashing] = useState(false);
  const [trend, setTrend] = useState<Trend>('stable');

  useEffect(() => {
    if (!data) return;
    if (prevRate.current !== undefined && prevRate.current !== data.rate) {
      const prev = prevRate.current;
      const curr = data.rate;
      setTrend(curr > prev ? 'up' : curr < prev ? 'down' : 'stable');
      setFlashing(true);
      setTimeout(() => setFlashing(false), 300);
    }
    prevRate.current = data.rate;
  }, [data]);

  return { rate: data?.rate ?? null, trend, flashing };
}
